// Stores
import type { TMenuSibebar } from '@/stores/TemaStore';

// Router
import { cTEMA_FINANCEIRO_ROUTES } from '@/router/temas/rotasTemaFinanceiro';

// Shared
import ECodificacao from '@/shared/enums/ECodificacao';

// Public
import jsonMenus from '../../../assets/data/menus_dashboards.json';

const menusTemaFinanceiro = jsonMenus.temaFinanceiro;

const cMENUS_TEMA_FINANCEIRO: TMenuSibebar[] = [
  {
    id: menusTemaFinanceiro.children.resumoReceber.id,
    titulo: menusTemaFinanceiro.children.resumoReceber.titulo,
    icone: menusTemaFinanceiro.children.resumoReceber.icone,
    corIcone: menusTemaFinanceiro.children.resumoReceber.corIcone,
    codificacao: ECodificacao.TemaFinanceiro,
    nameRoute: cTEMA_FINANCEIRO_ROUTES.ResumoReceber.name,
  },

  {
    id: menusTemaFinanceiro.children.resumoPagar.id,
    titulo: menusTemaFinanceiro.children.resumoPagar.titulo,
    icone: menusTemaFinanceiro.children.resumoPagar.icone,
    corIcone: menusTemaFinanceiro.children.resumoPagar.corIcone,
    codificacao: ECodificacao.TemaFinanceiro,
    nameRoute: cTEMA_FINANCEIRO_ROUTES.ResumoPagar.name,
  },

  {
    id: menusTemaFinanceiro.children.pagarReceber.id,
    titulo: menusTemaFinanceiro.children.pagarReceber.titulo,
    icone: menusTemaFinanceiro.children.pagarReceber.icone,
    corIcone: menusTemaFinanceiro.children.pagarReceber.corIcone,
    codificacao: ECodificacao.TemaFinanceiro,
    nameRoute: cTEMA_FINANCEIRO_ROUTES.PagarReceber.name,
  },

  {
    id: menusTemaFinanceiro.children.inadimplencia.id,
    titulo: menusTemaFinanceiro.children.inadimplencia.titulo,
    icone: menusTemaFinanceiro.children.inadimplencia.icone,
    corIcone: menusTemaFinanceiro.children.inadimplencia.corIcone,
    codificacao: ECodificacao.TemaFinanceiro,
    nameRoute: cTEMA_FINANCEIRO_ROUTES.Inadimplencia.name,
  },

  {
    codificacao: ECodificacao.TemaFinanceiro,
    id: menusTemaFinanceiro.children.personalizado.id,
    icone: menusTemaFinanceiro.children.personalizado.icone,
    titulo: menusTemaFinanceiro.children.personalizado.titulo,
    corIcone: menusTemaFinanceiro.children.personalizado.corIcone,
    nameRoute: cTEMA_FINANCEIRO_ROUTES.Personalizado.Gerenciador.name,
  },
] as const;

export default cMENUS_TEMA_FINANCEIRO;
